import { motion } from "framer-motion";
import HeroFloatingIcons from "../../Components/HeroFloatingIcons/HeroFloatingIcons";
import { heroIcons, socialIcons } from "../../Constants/Constants";
import {
  fadeIn,
  slideIn,
  staggerContainer,
} from "../../Constants/FramerMotions";
import CV from "./Puneet.pdf";
import "./hero.scss";

const Hero = () => {
  return (
    <motion.div
      className="hero-container"
      id="Hero"
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
    >
      {/* HERO LEFT SECTION */}
      <div className="hero-left">
        {/* hero name section */}
        <div className="hero-name">
          <motion.span
            variants={fadeIn("up", "tween", 0.3, 0.4)}
            className="greetings"
          >
            Hy, I Am <span className="wave">🤚</span>
          </motion.span>
          <div className="typewrite-name">
            <span>Puneet Sharma</span>
          </div>
          <span className="designation">Front End Developer</span>
        </div>

        {/* download cv  */}
        <a
          className="hire-me-link"
          href={CV}
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="hire-me-btn button-with-hover">Download CV</button>
        </a>

        {/* social media icons */}
        <motion.div
          className="social-icons"
          variants={fadeIn("left", "tween", 0.5, 0.4)}
        >
          <a
            href="https://www.linkedin.com/in/puneetsharma997"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={socialIcons.linkedin} alt="" />
          </a>
          <a
            href="https://github.com/puneetsharma997"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={socialIcons.github} alt="" />
          </a>
        </motion.div>
      </div>

      {/* HERO RIGHT SECTION */}
      <div className="hero-right">
        <motion.div
          variants={fadeIn("right", "tween", 0, 0)}
          className="main-character"
        >
          <img className="vector-orange" src={heroIcons.vectorOrange} alt="" />
          <img
            className="character-image"
            src={heroIcons.heroCharacter}
            alt=""
          />
        </motion.div>

        {/* ANIMATED CARDS AND EMOJIS */}
        <motion.div
          variants={fadeIn("left", "tween", 0.3, 0.4)}
          className="emoji-div"
        >
          <img src={heroIcons.glassEmoji} alt="" />
        </motion.div>

        <HeroFloatingIcons
          image={heroIcons.crown}
          text1="Web"
          text2="Developer"
          className="web-dev-div"
          variants={slideIn("right", "tween", 0.1, 0.4)}
        />

        <HeroFloatingIcons
          image={heroIcons.thumbsUp}
          text1="Best Design"
          className="best-design-div"
          variants={slideIn("right", "tween", 0.2, 0.4)}
        />

        {/* COLORFUL BLUR DIVS */}
        <div
          className="blur blur1"
          style={{ background: "rgb(238 210 255)" }}
        ></div>
        <div className="blur blur2" style={{ background: "#C1F5FF" }}></div>
      </div>
    </motion.div>
  );
};

export default Hero;
